export default __webpack_public_path__ + "static/media/GFiguradoCLosed.a34d135f.jpg";